module.exports = __webpack_public_path__ + "media/slide2/contractMediaSlide2Part1vs-840a1fc0.png";